/**
 * FY (Financial Year) quarter utilities shared across management fee components.
 *
 * FY quarters follow the Indian financial year:
 *   Q1 = Apr–Jun, Q2 = Jul–Sep, Q3 = Oct–Dec, Q4 = Jan–Mar (next year)
 *
 * Quarter labels use the format "Q1-2026" where the year is the FY start year.
 */

export const getCurrentFYQuarter = (): string => {
    const today = new Date();
    const month = today.getMonth() + 1;
    if (month >= 4 && month <= 6) return `Q1-${today.getFullYear()}`;
    if (month >= 7 && month <= 9) return `Q2-${today.getFullYear()}`;
    if (month >= 10 && month <= 12) return `Q3-${today.getFullYear()}`;
    return `Q4-${today.getFullYear() - 1}`;
};

/**
 * Formats a quarter label like "Q1-2026" into a human-readable string.
 * e.g. "Q1-2026" → "Q1 FY27 (Apr-Jun 2026)"
 */
export const formatQuarterLabel = (q: string): string => {
    const [qtr, year] = q.split("-");
    const fy = parseInt(year);
    const monthRanges: Record<string, string> = {
        Q1: `Apr-Jun ${fy}`,
        Q2: `Jul-Sep ${fy}`,
        Q3: `Oct-Dec ${fy}`,
        Q4: `Jan-Mar ${fy + 1}`,
    };
    return `${qtr} FY${(fy + 1).toString().slice(-2)} (${monthRanges[qtr]})`;
};
